import React from 'react';
import { ContextWidget } from '../../types/api/Widget';
import { WidgetType } from '../../types/api/ElementType';
import { Icons } from '../../components/atoms/SVG';
import { DefaultContextWidget } from '../_utils/asDefaultWidget/DefaultContextWidget';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { AttributeGroupInfoBlock } from '../../_blocks/AttributeGroupInfo';

export type AttributeGroupInfoWidget = ContextWidget<AttributeGroupInfoBlock, WidgetType.attributegroupinfo>;

export function AttributeGroupInfoWidget(props: AttributeGroupInfoWidget) {
  const { t } = useSonTranslation('AttributeGroups');
  return <DefaultContextWidget icon={Icons.INFO_BOX} title={t('groupInformation')} {...props} />;
}
